export default function range(start, length) {
	var array = new Array();
	var j = 0;
	for (var i = start; i < length; i++) {
		array[j++] = i;
	}
	return array;
}


// WEBPACK FOOTER //
// ./app/shared/arrayRange.js